<!-- =========================================================================================
    File Name: Carousel.vue
    Description: Carousel demo
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="extra-component-vue-awesome-swiper-demo">

        
    <div id="demo-basic-card">
        <div class="vx-row">
            
            <div class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base" v-for="domaine in domaineT">
                <vx-card :title="domaine.nom_domaine" >
                    
                    <img :src="domaine.image" alt="content-img" class="responsive rounded-lg">
                    
                          
                          <div class="flex justify-between flex-wrap">
                              
                              <h5 class="mt-6 ml-5">{{ domaine.nb_formation}}  Formation </h5>
                              <vs-button class="mt-4 mr-5 " @click="lister(domaine.id)" type="border" color="#b9b9b9">Lister</vs-button>
                           </div>
                        
                    
                </vx-card>
            </div>
        </div>
    </div>
    
    </div>
    
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { videoPlayer }     from 'vue-video-player'
import VxTimeline          from "@/components/timeline/VxTimeline.vue"
import 'video.js/dist/video-js.css'
import moduledomaine from '@/store/domaine/moduledomaine.js'
export default {
  components: {
 
  },
  data() {
    return {
     
    }
  },
  computed: {
    domaineT() {
      console.log(this.$store.state.domaine.users)
      return this.$store.state.domaine.users
    },
    
  },
  watch: {
   
    },
  methods: {
    
    lister(id){
      console.log(id)
      this.$router.push("/formation/domaine/" + id)
    }
    
  },
  created() {
    if(!moduledomaine.isRegistered) {
      this.$store.registerModule('domaine', moduledomaine)
      moduledomaine.isRegistered = true
    }
    console.log('rfffffffffff')
    this.$store.dispatch("domaine/fetchUsers")
    
  },
  mounted() {
   
  }
}
</script>
<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
}
</style>
